import { createApp } from 'vue'
import App from './App.vue'
import $axios from './core/api.service'
import './services/investor.service'
import { filters } from './core/filters'
import router from './router'
import { pinia } from './stores'
import { setupPlugins } from './plugins'
import '@/assets/styles/main.scss'
import i18n from './i18n'
import './plugins/vee-validate'
import './core/validationRules'
import IdleVueComponent from './components/layout/IdleView'
import { useCompanyStore } from './stores/company'

const app = createApp(App)

// Setup plugins
setupPlugins(app)

// Idle functionality now handled by VueUse's useIdle composable in IdleView.vue component
app.component('idle-view', IdleVueComponent)

app.use(pinia)
app.use(router)
app.use(i18n)

// Configure axios for Vue 3
app.config.globalProperties.$axios = $axios

// Configure filters as global properties for Vue 3
Object.keys(filters).forEach(key => {
  app.config.globalProperties[`$${key}`] = filters[key]
})

// Initialize white label - this will be handled by the company store
const companyStore = useCompanyStore()
companyStore.initializeWhiteLabel().finally(() => {
  /* Mount into #app, not <body>. Vue clears the container on mount, and this
     runs after an async request - mounting onto body wiped anything else that
     had been added to it in the meantime. */
  app.mount('#app')
})

